export default "__VITE_ASSET__BGYy$dZO__"